export default __webpack_public_path__ + "static/media/img-thank-you.03b006d0.png";